<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="pa-3">
          <v-layout row wrap>
            
            <v-flex md3 class="pl-1">
              <v-menu
                v-model="invoiceDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="reportFilters.date"
                    label="Date from"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reportFilters.date"
                  @input="invoiceDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md3 class="pl-1">
              <v-menu
                v-model="invoiceDateMenu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="reportFilters.date2"
                    label="Date To"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="reportFilters.date"
                  v-model="reportFilters.date2"
                  @input="invoiceDateMenu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex md6 class="text-xs-right">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="primary"
                    fab
                    small
                    dark
                    @click="isSearchModal = true"
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>
                <span>Advance Search</span>
              </v-tooltip>
            </v-flex>
          </v-layout>

          <ListLoader v-if="isLoadingContent"></ListLoader>
          <div class="simple-table-container" id="invoice-dues-report" v-else>
            <div class="hidden-screen-only report-header text-center">
              <div class="head">
                {{ settings && settings.company_name }}
              </div>
              <div class="address">
                {{ settings && settings.company_address }}
              </div>
              <hr />
              <br />
              <div class="title">
                 Expense Report -
                {{
                  reportFilters.date == reportFilters.date2
                    ? reportFilters.date
                    : `${reportFilters.date} to ${reportFilters.date2}`
                }}
              </div>
            </div>
            <table class="table table-bordered">
              <tr>
                <tr>
                <th>Expense Date</th>
                <th>Invoice No.</th>
                <th>Company</th>
                <th>Client</th>
                <th>Project</th>
                <th>Head</th>
                <th>Amount</th>
              </tr>
              </tr>
              <tr v-for="item in (reportData.invoice_expenses || [])" :key="item.id">
                <td>{{ item.payment_date }}</td>
                <td>{{ item.invoices___invoice_number }}</td>
                <td>{{ item.companies___name }}</td>
                <td>{{ item.clients___name }}</td>
                <td>{{ item.invoices___client_project_name }}</td>
                <td>{{ item.account_heads___title }}</td>
                <td>{{ item.amount }}</td>
              </tr>
              <tr>
                <td colspan="9" class="report-sum text-center">
                  Total Invoice Expenses &nbsp;&nbsp; {{ mA(invoiceExpensesAmountSum) }}
                </td>
              </tr>
            </table>
            <br>

          <div v-if="isShowCommissionSection">
            <table class="table table-bordered">
              <tr>
                <tr>
                <th>Invoice Date</th>
                <th>Invoice No.</th>
                <th>Company</th>
                <th>Client</th>
                <th>Project</th>
                <th>Coordinator</th>
                <th>Commission</th>
              </tr>
              </tr>
              <tr v-for="item in commissionExpenses" :key="item.id">
                <td>{{ item.invoice_date }}</td>
                <td>{{ item.invoice_number }}</td>
                <td>{{ item.companies___name }}</td>
                <td>{{ item.clients___name }}</td>
                <td>{{ item.client_project_name }}</td>
                <td>{{ item.coordinators___name }}</td>
                <td>{{ item.commission_amount }}</td>
              </tr>
              <tr>
                <td colspan="9" class="report-sum text-center">
                  Total Commission Expenses &nbsp;&nbsp; {{ mA(commissionExpensesAmountSum  ) }}
                </td>
              </tr>
            </table>
            <br>
            </div>

            <table class="table table-bordered">
              <tr>
                <tr>
                <th>Expense Date</th>
                <th>Company</th>
                <th>Head</th>
                <th>Amount</th>
              </tr>
              </tr>
              <tr v-for="item in (reportData.company_expenses || [])" :key="item.id">
                <td>{{ item.payment_date }}</td>
                <td>{{ item.companies___name }}</td>
                <td>{{ item.account_heads___title }}</td>
                <td>{{ item.amount }}</td>
              </tr>
              <tr>
                <td colspan="9" class="report-sum text-center">
                  Total Company specific Expenses &nbsp;&nbsp; {{ mA(companyExpensesAmountSum) }}
                </td>
              </tr>
            </table>
            <br>
            <table class="table table-bordered">
              <tr>
                <tr>
                <th>Expense Date</th>
                <th>Head</th>
                <th>Amount</th>
              </tr>
              </tr>
              <tr v-for="item in nonCompanyExpenses" :key="item.id">
                <td>{{ item.payment_date }}</td>
                <td>{{ item.account_heads___title }}</td>
                <td>{{ item.amount }}</td>
              </tr>
              <tr>
                <td colspan="9" class="report-sum text-center">
                  Total Company non specific/common Expenses &nbsp;&nbsp; {{ mA(nonCompanyExpensesAmountSum) }}
                </td>
              </tr>
            </table>
            <br>
            <h4 align="center" class="headline">Total Expenses {{ mA(invoiceExpensesAmountSum + companyExpensesAmountSum + nonCompanyExpensesAmountSum + commissionExpensesAmountSum) }}</h4>
            
          </div>
          <v-card-actions>
            <v-btn flat @click="print()">Print</v-btn>
            <!-- <v-btn flat >Explore</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="isSearchModal" scrollable persistent max-width="500px">
      <AdvanceSearch
        :rfilters="reportFilters"
        :hide="['date', 'date2', 'client', 'coordinator']"
        @cancelled="isSearchModal = false"
      />
    </v-dialog>
  </div>
</template>



<script>
import { ContentLoader, ListLoader } from "vue-content-loader";
import AdvanceSearch from "../SearchModal";
import { columnSum } from "../../mdsir/MdsirUtils";
import { MYSQL_DATE_FORMAT } from "../../mdsir/const";

export default {
  components: {
    ContentLoader,
    ListLoader,
    AdvanceSearch,
  },
  data: () => ({
    isSearchModal: false,
    isLoadingContent: false,
    invoiceDateMenu: false,
    invoiceDateMenu2: false,
    reportFilters: {
      date: null,
      date2: null,
    },
    reportData: [],
  }),

  computed: {
    invoiceExpensesAmountSum() {
      return columnSum((this.reportData.invoice_expenses || []), 'amount');
    },
    companyExpensesAmountSum() {
      return columnSum((this.reportData.company_expenses || []), 'amount');
    },
    nonCompanyExpenses() {
      const ncex = this.reportData.non_company_expenses || [];
      const company_count  = this.reportData.company_count || 1;

      return this.reportFilters.company_id ? 
      ncex.map(r => ({ ...r, amount: r.amount/company_count})) : ncex;
    },
    nonCompanyExpensesAmountSum() {
      return columnSum(this.nonCompanyExpenses, 'amount');
    },
    commissionExpenses() {
      const cEx = this.reportData.invoice_commission_expenses || [];

      return cEx.map(r => ({ ...r, commission_amount: (r.amount - r.vat_amount - r.expense_amount) * r.coordinator_commission_parcent/100 }));
    },
    commissionExpensesAmountSum() {
      return columnSum(this.commissionExpenses, 'commission_amount');
    },
    isShowCommissionSection(){
      return this.reportFilters && this.reportFilters.account_head_id && this.reportFilters.account_head_id > 0 ? false : true;
    }
  },

  watch: {
    reportFilters: {
      handler: function (val, oldVal) {
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {},

  mounted() {
    this.reportFilters.date = this.$moment().startOf("month").format(MYSQL_DATE_FORMAT);
    this.reportFilters.date2 = this.$moment().endOf("month").format(MYSQL_DATE_FORMAT);
    // this.getDataFromApi();
  },

  methods: {
    getDataFromApi() {
      this.isLoadingContent = true;
      this.get("/expense_report", this.reportFilters).then((response) => {
        this.reportData = response.data;
        this.isLoadingContent = false;
      });
    },
    print() {
      this.$htmlToPaper("invoice-dues-report");
    },
  },

  beforeDestroy() {},
};
</script>

<style scoped>
.simple-table-container {
  overflow: auto;
}
.table {
  border-collapse: collapse;
  width: 100%;
}
.table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #bebebe;
}

.table td,
.table th {
  border: 1px solid #ddd;
  padding: 8px;
}

.table td.report-sum {
  padding: 6px;
  text-align: center;
  background-color: #0f0f0f0e;
  font-size: 20px;
  font-weight: bold;
}
</style>